@if (!formsDisabled) {
    <table
        class="table table-center table-add-row"
        [class.disabled]="formsDisabled"
        [class.table-last-col]="!formsDisabled">
        <tr>
            <th class="molen">Molen</th>
            <th class="cutter-selection" [matTooltip]="'asphalttype' | tt">Type asfalt</th>
            <th class="number-input" [matTooltip]="'asphaltcode' | tt">Code centrale</th>
            <th class="number-input">Ton</th>
            <th class="number-input">Dikte <small>mm</small></th>
            <th [matTooltip]="'asphalt-trucks-time' | tt">Tijdstip</th>
            <th class="number-input" [matTooltip]="'trucks-count' | tt">Vrachtwagens</th>
            <th class="comment">Opmerking</th>
            @if (!formsDisabled) {
                <th></th>
            }
        </tr>
        @for (planningAsphalt of planningAsphaltList; track planningAsphalt) {
            <tr
                [asphaltMills]="asphaltMills"
                [availableTrucks]="availableTrucks.get(planningAsphalt)"
                [formsDisabled]="formsDisabled"
                [mainPlanning]="mainPlanning"
                [maxUsedTrucks]="maxUsedTrucks.get(planningAsphalt)"
                [planningAsphalt]="planningAsphalt"
                [planning]="planning"
                [timeList]="timeList"
                (delete)="removeAsphaltPlanning(planningAsphalt)"
                (reOrder)="reorder()"
                (updateTrucks)="trucks()"
                app-asphalt-list-item></tr>
        }
        <tr [hidden]="formsDisabled">
            <td colspan="8">
                <button class="w-100" (click)="addAsphaltPlanning()" color="primary" mat-button>
                    Toevoegen <i class="fas fa-plus"></i>
                </button>
            </td>
            <td></td>
        </tr>
    </table>
} @else if (formsDisabled) {
    <table class="table table-center">
        <tr>
            <th>Molen</th>
            <th>Type asfalt</th>
            <th width="130">Code centrale</th>
            <th class="number-input">Ton</th>
            <th class="number-input">Dikte <small>mm</small></th>
            <th>Tijdstip</th>
            <th class="number-input">Vrachtwagens</th>
            <th width="250">Opmerking</th>
        </tr>
        @for (planningAsphalt of planning.asphalt_list; track planningAsphalt) {
            <tr>
                @if (asphaltMills) {
                    <td>
                        {{ (asphaltMills | byId: planningAsphalt.asphaltmill_id)?.name }}
                    </td>
                }
                <td>{{ planningAsphalt.asphaltname }}</td>
                <td>{{ planningAsphalt.asphaltcode }}</td>
                <td>{{ planningAsphalt.tons }}</td>
                <td>{{ planningAsphalt.thickness }}</td>
                <td>{{ planningAsphalt.time | date: 'EEE H:mm' }}</td>
                <td>{{ planningAsphalt.trucks }}</td>
                <td>{{ planningAsphalt.comment }}</td>
            </tr>
        }
    </table>
}
